// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* HospitalDetails.css */
/* Page transition effect */
.hospital-details-container-enter {
  opacity: 0;
  transform: translateX(-50px);
}

.hospital-details-container-appear-done{
  /* margin-right: 200px; */
  padding-left: 10px;
  /* width: calc(100vw - 210px); */
  /* margin-top: -10px; */
  padding-top: 10px;
  z-index: 1;
}

.css-1080nhc-MuiButtonBase-root-MuiTab-root.Mui-selected{
  /* border-left: solid 4px #0056b3;
  border-right: solid 4px #0056b3;
  border-top: solid 4px #0056b3; */
  border-radius: 15px 15px 0px 0px;
  box-shadow: 0px 0px 4px #0056b3;
  border-style: groove;
  /* border-start-start-radius: 50%;
  border-block-color: transparent; */
  background-color: #0056b3;
  color: #FFFFFF !important;
}

.hospital-details-container-enter-active {
  opacity: 1;
  transform: translateX(0);
  transition: opacity 500ms, transform 500ms;
}

.hospital-details-container-exit {
  opacity: 1;
  transform: translateX(0);
}

.hospital-details-container-exit-active {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 500ms, transform 500ms;
}

.hospital-details-container {
  display: flex;
  justify-content: space-between;
  /* background-color: #F0EEF0; */
}
@media (max-width: 1106px) {
  .hospital-details-container {
    flex-direction: column;
  
    justify-content: start !important;
  }
}


.hospital-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 15px 20px;
  background-color: #E2E3E5;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: calc(100vw - 260px);
  border-bottom: solid 2px E2E3E5;
  padding-bottom: 15px;
}

.hospital-header-min{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 15px 20px;
  background-color: #E2E3E5;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: calc(100vw - 170px);
  border-bottom: solid 2px E2E3E5;
  padding-bottom: 15px;
}

.hospital-header-main{
  display: flex;
  z-index: 4;
  position: fixed;
  margin-top: -10px;
  padding-top: 10px;
  background-color: #FFFFFF;
  margin-left: -10px;
  padding-left: 10px;
}


.hospital-header .back-arrow-icon {
  margin-right: 20px;
  cursor: pointer;
  font-size: 20px;
  color: #007bff;
}

.hospital-header .back-arrow-icon:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.hospital-header .client-name {
  font-size: 24px;
  font-weight: bold;
}

.hospital-tabs {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin-top: 100px;
 
}
.css-1aquho2-MuiTabs-indicator{
 display: none;
}
.css-jpln7h-MuiTabs-scroller{
  margin-top: 60px;
  padding-top: 20px;
  width: calc(100vw - 0px) !important;
  display: flex !important;
  justify-content: center;
  z-index: 4;
  position: fixed !important;
  background-color: #FFFFFF;
  left: 0;
}

.css-15es4mv-MuiTabs-root{
  height: 150px;
  background-color: #FFFFFF;
}

/* Left section styles */
.hospital-section {
  width: 48%; /* Adjust the width as needed */
  padding: 10px;
  box-sizing: border-box; 
 

}
@media (max-width: 900px) {
  .hospital-section {
    display: block;
    width: 100%;
  }
  .css-1wf8b0h-MuiTabs-flexContainer{
    flex-direction: row;
    overflow: auto;
    margin-left: 130px !important;
    margin-right: 200px !important;
    padding-left: 300px !important;
  }
  .css-jpln7h-MuiTabs-scroller{
    padding-left: 20%;
    justify-content: flex-start !important;
  }
  .tabs{
    margin-left: -273px;
  }
  .css-15es4mv-MuiTabs-root{
    /* height: 380px; */
    background-color: #FFFFFF;
  }
 
}
.css-1wf8b0h-MuiTabs-flexContainer{
  border-bottom: solid 1px grey ;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 300px;
}
.tabs{
  width: calc(100vw-200px);
  display: block;
}

.hospital-label {
  font-weight: bold;
  color: #02098d;
}

.hospital-value {
  color: #444;
}

/* Right section styles */
.hospital-section:last-child {
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 20px;
}

.hospital-toggle-label {
  font-size: medium;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  
}

.hospital-toggle-value {
  display: flex;
  align-items: center;
}

.hospital-toggle-value .MuiSvgIcon-root {
  font-size: 18px;
}

/* Custom colors for the toggle buttons */
.hospital-toggle-value .MuiToggleButton-root.Mui-selected {
  background-color: #007bff;
  color: #fff;
}

/* Custom styles for account status toggle */
.hospital-toggle-value .blocked {
  color: #f44336;
}


/* Add this to your HospitalDetails.css or a separate CSS file */
.billing-type-bar {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: #f0f0f0;
  color: #555;
}

.billing-type-bar.updated {
  background-color: #3f51b5; /* Change this color as needed */
  color: #fff;
}

.hospital-grid {
  display: grid;
  grid-template-columns: auto auto; /* Two columns, adjust as needed */
  gap: 10px; /* Adjust the gap between label and value as needed */
}

.hospital-label {
  font-weight: bold;
  font-size: 15px; /* Increase label font size */
  /* background-color: #e2e5f9; Rounded rectangular bar background color */
  padding: 5px 10px; /* Padding for the rounded rectangular bar */
  border-radius: 20px; /* Adjust the border radius for the rounded effect */
  /* border: 1px solid #bcbcbc; */
  margin-top: 10px;
  height: -moz-fit-content;
  height: fit-content;
  text-decoration: none;
  width: 120px;
  display: flex;
  justify-content: space-between;
}

.hospital-value {
  margin-top: 5px;
  font-size: 15px; /* Increase value font size */
  /* background-color: #f5f5f5; Rounded rectangular bar background color */
  padding: 10px 20px; /* Padding for the rounded rectangular bar */
  border-radius: 20px; /* Adjust the border radius for the rounded effect */
  /* border: 1px solid #bcbcbc;
  height: fit-content; */
  text-decoration: none;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  width: 300px;
  
  white-space: nowrap;
}

.hospital-valuer::after {
  content: "\\00a0,\\00a0";
  word-wrap: break-word; /* Add a non-breaking space and a comma */
}

.value-input{
  width:300px;
  text-decoration: none;
  border: none;
  height: 25px;
  /* margin-top: -30px; */
}

.hospital-toggle-label {
  font-weight: bold; /* Increase label font size */
  margin-top: 10px; /* Add some spacing between the sections */
  border-radius: 4px;
  /* background-color: #f8f9fc; Rounded rectangular bar background color */
  padding: 6px 10px;
  
  font-size: 14px;
  color: #02098d;
  box-shadow: 0px 0px 2px grey;
  width: calc(100% - 10%);
  /* border: 1px solid #bcbcbc; */
}



/* Add styles for the billing type bar */
.billing-type-bar { /* Increase font size for the billing type bar */
  background-color: #e2e5f9; /* Rounded rectangular bar background color */
  padding: 5px 10px; /* Padding for the rounded rectangular bar */
  border-radius: 10px; /* Adjust the border radius for the rounded effect */
  display: inline-block; /* Ensure the bar wraps around the content */
  font-size: 16px;
}


/* HospitalDetails.css */

/* Common heading style for SLABS and Agreed Price sections */
.section-heading {
  font-size: 20px !important;
  font-weight: bold !important;
  margin-bottom: 10px;
  text-align: center; /* Center align the heading */
  position: sticky;
  color: #007bff;
  letter-spacing: 1px !important;
}

/* SLABS Section */
.slab-section {
  margin: 10px;
  background-color: #fdfdfd; /* Set SLABS section background */
 /* border: 1px solid #e0e0e0;  Add border to SLABS section */
 border:none;
  border-radius: 10px;
  padding: 20px;
  flex-grow: 1; /* Allow SLABS section to grow and take available vertical space */
  overflow-y: auto; 
  height: calc(100vh - 260px);
  position: sticky;
  background-color: white;
  box-shadow: 0px 0px 5px grey ;
  font-family:Roboto, Helvetica, sans-serif;
  font-size: 13px;
}

.modality-heading {
  font-size: 18px !important;
  font-weight: 500 !important;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 10px;
  background-color: #e0f2f7;
  margin-top: 10px !important;
}

.slab-data {
  display: flex;
  align-items: center;
  /* margin-bottom: 10px; */
  background-color: #f4f7f8; /* Set SLAB row background */
  padding: 10px;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(235, 133, 133, 0.1);
}

/* to target the head of the each slab */
.slab-data-head{
    font-weight: 700 !important;
}

.slab-data > div {
  flex: 1 1;
  padding:5px 10px;
  text-align: center;
}

.slab-data-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  background-color: #c6bff0; /* Set SLAB column header background */
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.add-slabs-button {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  margin-left: 80% !important;
  font-size: 11px !important;
}

.update-icons {
  display: flex;
}

.update-icons > button {
  margin-left: 5px;
}

/* Agreed Price Section */
.agreed-price-section {
  margin: 10px;
  padding: 10px;
  background-color:#FFFFFF; /* Set Agreed Price section background */
   /* Add border to Agreed Price section */
  border-radius: 10px;
  box-shadow: 0 1px 5px grey;
  flex-grow: 1; /* Allow Agreed Price section to grow and take available vertical space */
  /* overflow-y: auto;  */
  height: calc(100vh - 240px);
}
.css-rqglhn-MuiTable-root{
 overflow-y: auto;
 height: 300p;
}

.agreed-heading {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.slab-agreed-container {
  display: flex;
}

/* HospitalDetails.css */

/* ... (existing CSS code) */

.buttons-container {
display: flex;
justify-content: flex-end;
margin-bottom: 10px;
}

/* ... (existing CSS code) */
.agreed-heading.section-heading {
font-size: 20px;
font-weight: bold;
margin-bottom: 10px;
text-align: center; /* Center align the heading */
color: #007bff; /* Change the font color to blue (you can use any color you prefer) */
}

.css-8je8zh-MuiTouchRipple-root {

color: white;
}


.details-li{
display: flex;
box-shadow: 0px 0px 2px grey;
text-decoration: none;
margin-bottom: 10px;
border-radius: 4px;
justify-content: space-between;
}

.details-li:hover{
background-color: #c6bff0;
border-radius: 5px;
}

.hospital-toggle-label:hover{
background-color: #c6bff0;
}

.pop-edit{
display: block;
}

.pop-btn{
background-color: #0056b3;
border: none;
padding: 5px 10px;
margin-top: 10px;
margin-right: 20px;
border-radius: 50px;
width: 70px;
}

.css-i4bv87-MuiSvgIcon-root{
cursor: pointer;
}

.css-1u3bzj6-MuiFormControl-root-MuiTextField-root{
width: 300px;

}

/* target the button in price tab */
.price-btn{
  margin-right: 5px !important;
  font-size: 11px !important;
}

.edit-label>label{
  margin-top: 0px;
  font-size: 16px !important;
}

.edit-value{
  overflow-x: scroll;
  margin-right: 15px ;
}

.edit-value::-webkit-scrollbar {
  display: none;
}

.edit-value {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}


.price-table td,th{
  padding: 16px;
}

/* button{
  margin: 20px 0px 20px 0px;
  text-align: center;
} */
.custom-btn {
 
  width: 130px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 25px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
   box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
   7px 7px 20px 0px rgba(0,0,0,.1),
   4px 4px 5px 0px rgba(0,0,0,.1);
  outline: none;
}

.btn-3 {
  background: rgb(0,172,238);
background: linear-gradient(0deg, rgba(0,172,238,1) 0%, rgba(2,126,251,1) 100%);
  width: 130px;
  height: 40px;
  line-height: 42px;
  padding: 0;
  border: none;
  
}
.btn-3 span {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.btn-3:before,
.btn-3:after {
  position: absolute;
  content: "";
  right: 0;
  top: 0;
   background: rgba(2,126,251,1);
  transition: all 0.3s ease;
}
.btn-3:before {
  height: 0%;
  width: 2px;
}
.btn-3:after {
  width: 0%;
  height: 2px;
}
.btn-3:hover{
   background: transparent;
  box-shadow: none;
}
.btn-3:hover:before {
  height: 100%;
}
.btn-3:hover:after {
  width: 100%;
}
.btn-3 span:hover{
   color: rgba(2,126,251,1);
}
.btn-3 span:before,
.btn-3 span:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
   background: rgba(2,126,251,1);
  transition: all 0.3s ease;
}
.btn-3 span:before {
  width: 2px;
  height: 0%;
}
.btn-3 span:after {
  width: 0%;
  height: 2px;
}
.btn-3 span:hover:before {
  height: 100%;
}
.btn-3 span:hover:after {
  width: 100%;
}

`, "",{"version":3,"sources":["webpack://./src/components/Hospital/HospitalDetails.css"],"names":[],"mappings":";AACA,wBAAwB;AACxB,2BAA2B;AAC3B;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;;kCAEgC;EAChC,gCAAgC;EAChC,+BAA+B;EAC/B,oBAAoB;EACpB;oCACkC;EAClC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE;IACE,sBAAsB;;IAEtB,iCAAiC;EACnC;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;;AAEnB;AACA;CACC,aAAa;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,wBAAwB;EACxB,uBAAuB;EACvB,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,UAAU,EAAE,+BAA+B;EAC3C,aAAa;EACb,sBAAsB;;;AAGxB;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,sCAAsC;EACxC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;AAEF;AACA;EACE,8BAA8B;EAC9B,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;;AAEvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;;AAGA,gEAAgE;AAChE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC,EAAE,kCAAkC;EACpE,SAAS,EAAE,qDAAqD;AAClE;;AAEA;EACE,iBAAiB;EACjB,eAAe,EAAE,6BAA6B;EAC9C,wEAAwE;EACxE,iBAAiB,EAAE,4CAA4C;EAC/D,mBAAmB,EAAE,oDAAoD;EACzE,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,eAAe,EAAE,6BAA6B;EAC9C,wEAAwE;EACxE,kBAAkB,EAAE,4CAA4C;EAChE,mBAAmB,EAAE,oDAAoD;EACzE;wBACsB;EACtB,qBAAqB;EACrB,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,YAAY;;EAEZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB,EAAE,yCAAyC;AAClE;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB,EACA,6BAA6B;EAC9C,gBAAgB,EAAE,0CAA0C;EAC5D,kBAAkB;EAClB,wEAAwE;EACxE,iBAAiB;;EAEjB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;AACjC;;;;AAIA,wCAAwC;AACxC,oBACmB,gDAAgD;EACjE,yBAAyB,EAAE,6CAA6C;EACxE,iBAAiB,EAAE,4CAA4C;EAC/D,mBAAmB,EAAE,oDAAoD;EACzE,qBAAqB,EAAE,4CAA4C;EACnE,eAAe;AACjB;;;AAGA,wBAAwB;;AAExB,6DAA6D;AAC7D;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB,EAAE,6BAA6B;EACjD,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EAEE,YAAY;EACZ,yBAAyB,EAAE,iCAAiC;CAC7D,4DAA4D;CAC5D,WAAW;EACV,mBAAmB;EACnB,aAAa;EACb,YAAY,EAAE,kEAAkE;EAChF,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB,EAAE,4BAA4B;EACvD,aAAa;EACb,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA,wCAAwC;AACxC;IACI,2BAA2B;AAC/B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB,EAAE,sCAAsC;EACjE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,aAAa;EACb,wBAAwB,EAAE,wCAAwC;GACjE,uCAAuC;EACxC,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY,EAAE,yEAAyE;EACvF,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;;AAExB,4BAA4B;;AAE5B;AACA,aAAa;AACb,yBAAyB;AACzB,mBAAmB;AACnB;;AAEA,4BAA4B;AAC5B;AACA,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,kBAAkB,EAAE,6BAA6B;AACjD,cAAc,EAAE,qEAAqE;AACrF;;AAEA;;AAEA,YAAY;AACZ;;;AAGA;AACA,aAAa;AACb,4BAA4B;AAC5B,qBAAqB;AACrB,mBAAmB;AACnB,kBAAkB;AAClB,8BAA8B;AAC9B;;AAEA;AACA,yBAAyB;AACzB,kBAAkB;AAClB;;AAEA;AACA,yBAAyB;AACzB;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,iBAAiB;AACjB,gBAAgB;AAChB,kBAAkB;AAClB,mBAAmB;AACnB,WAAW;AACX;;AAEA;AACA,eAAe;AACf;;AAEA;AACA,YAAY;;AAEZ;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;;AAGA;EACE,aAAa;AACf;;AAEA;;;GAGG;AACH;;EAEE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;GACpB;;iCAE8B;EAC/B,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B,+EAA+E;EAC7E,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,YAAY;;AAEd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,MAAM;GACL,6BAA6B;EAC9B,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;GACG,uBAAuB;EACxB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;GACG,wBAAwB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;GACR,6BAA6B;EAC9B,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb","sourcesContent":["\n/* HospitalDetails.css */\n/* Page transition effect */\n.hospital-details-container-enter {\n  opacity: 0;\n  transform: translateX(-50px);\n}\n\n.hospital-details-container-appear-done{\n  /* margin-right: 200px; */\n  padding-left: 10px;\n  /* width: calc(100vw - 210px); */\n  /* margin-top: -10px; */\n  padding-top: 10px;\n  z-index: 1;\n}\n\n.css-1080nhc-MuiButtonBase-root-MuiTab-root.Mui-selected{\n  /* border-left: solid 4px #0056b3;\n  border-right: solid 4px #0056b3;\n  border-top: solid 4px #0056b3; */\n  border-radius: 15px 15px 0px 0px;\n  box-shadow: 0px 0px 4px #0056b3;\n  border-style: groove;\n  /* border-start-start-radius: 50%;\n  border-block-color: transparent; */\n  background-color: #0056b3;\n  color: #FFFFFF !important;\n}\n\n.hospital-details-container-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 500ms, transform 500ms;\n}\n\n.hospital-details-container-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.hospital-details-container-exit-active {\n  opacity: 0;\n  transform: translateX(50px);\n  transition: opacity 500ms, transform 500ms;\n}\n\n.hospital-details-container {\n  display: flex;\n  justify-content: space-between;\n  /* background-color: #F0EEF0; */\n}\n@media (max-width: 1106px) {\n  .hospital-details-container {\n    flex-direction: column;\n  \n    justify-content: start !important;\n  }\n}\n\n\n.hospital-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 15px 20px;\n  background-color: #E2E3E5;\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  width: calc(100vw - 260px);\n  border-bottom: solid 2px E2E3E5;\n  padding-bottom: 15px;\n}\n\n.hospital-header-min{\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 15px 20px;\n  background-color: #E2E3E5;\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  width: calc(100vw - 170px);\n  border-bottom: solid 2px E2E3E5;\n  padding-bottom: 15px;\n}\n\n.hospital-header-main{\n  display: flex;\n  z-index: 4;\n  position: fixed;\n  margin-top: -10px;\n  padding-top: 10px;\n  background-color: #FFFFFF;\n  margin-left: -10px;\n  padding-left: 10px;\n}\n\n\n.hospital-header .back-arrow-icon {\n  margin-right: 20px;\n  cursor: pointer;\n  font-size: 20px;\n  color: #007bff;\n}\n\n.hospital-header .back-arrow-icon:hover {\n  color: #0056b3;\n  transform: scale(1.2);\n}\n\n.hospital-header .client-name {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.hospital-tabs {\n  background-color: #f5f5f5;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  margin-top: 100px;\n \n}\n.css-1aquho2-MuiTabs-indicator{\n display: none;\n}\n.css-jpln7h-MuiTabs-scroller{\n  margin-top: 60px;\n  padding-top: 20px;\n  width: calc(100vw - 0px) !important;\n  display: flex !important;\n  justify-content: center;\n  z-index: 4;\n  position: fixed !important;\n  background-color: #FFFFFF;\n  left: 0;\n}\n\n.css-15es4mv-MuiTabs-root{\n  height: 150px;\n  background-color: #FFFFFF;\n}\n\n/* Left section styles */\n.hospital-section {\n  width: 48%; /* Adjust the width as needed */\n  padding: 10px;\n  box-sizing: border-box; \n \n\n}\n@media (max-width: 900px) {\n  .hospital-section {\n    display: block;\n    width: 100%;\n  }\n  .css-1wf8b0h-MuiTabs-flexContainer{\n    flex-direction: row;\n    overflow: auto;\n    margin-left: 130px !important;\n    margin-right: 200px !important;\n    padding-left: 300px !important;\n  }\n  .css-jpln7h-MuiTabs-scroller{\n    padding-left: 20%;\n    justify-content: flex-start !important;\n  }\n  .tabs{\n    margin-left: -273px;\n  }\n  .css-15es4mv-MuiTabs-root{\n    /* height: 380px; */\n    background-color: #FFFFFF;\n  }\n \n}\n.css-1wf8b0h-MuiTabs-flexContainer{\n  border-bottom: solid 1px grey ;\n  width: fit-content;\n  margin-left: 300px;\n}\n.tabs{\n  width: calc(100vw-200px);\n  display: block;\n}\n\n.hospital-label {\n  font-weight: bold;\n  color: #02098d;\n}\n\n.hospital-value {\n  color: #444;\n}\n\n/* Right section styles */\n.hospital-section:last-child {\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding-left: 20px;\n}\n\n.hospital-toggle-label {\n  font-size: medium;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-decoration: none;\n  \n}\n\n.hospital-toggle-value {\n  display: flex;\n  align-items: center;\n}\n\n.hospital-toggle-value .MuiSvgIcon-root {\n  font-size: 18px;\n}\n\n/* Custom colors for the toggle buttons */\n.hospital-toggle-value .MuiToggleButton-root.Mui-selected {\n  background-color: #007bff;\n  color: #fff;\n}\n\n/* Custom styles for account status toggle */\n.hospital-toggle-value .blocked {\n  color: #f44336;\n}\n\n\n/* Add this to your HospitalDetails.css or a separate CSS file */\n.billing-type-bar {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 8px;\n  background-color: #f0f0f0;\n  color: #555;\n}\n\n.billing-type-bar.updated {\n  background-color: #3f51b5; /* Change this color as needed */\n  color: #fff;\n}\n\n.hospital-grid {\n  display: grid;\n  grid-template-columns: auto auto; /* Two columns, adjust as needed */\n  gap: 10px; /* Adjust the gap between label and value as needed */\n}\n\n.hospital-label {\n  font-weight: bold;\n  font-size: 15px; /* Increase label font size */\n  /* background-color: #e2e5f9; Rounded rectangular bar background color */\n  padding: 5px 10px; /* Padding for the rounded rectangular bar */\n  border-radius: 20px; /* Adjust the border radius for the rounded effect */\n  /* border: 1px solid #bcbcbc; */\n  margin-top: 10px;\n  height: fit-content;\n  text-decoration: none;\n  width: 120px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.hospital-value {\n  margin-top: 5px;\n  font-size: 15px; /* Increase value font size */\n  /* background-color: #f5f5f5; Rounded rectangular bar background color */\n  padding: 10px 20px; /* Padding for the rounded rectangular bar */\n  border-radius: 20px; /* Adjust the border radius for the rounded effect */\n  /* border: 1px solid #bcbcbc;\n  height: fit-content; */\n  text-decoration: none;\n  height: fit-content;\n  display: flex;\n  justify-content: space-between;\n  width: 300px;\n  \n  white-space: nowrap;\n}\n\n.hospital-valuer::after {\n  content: \"\\00a0,\\00a0\";\n  word-wrap: break-word; /* Add a non-breaking space and a comma */\n}\n\n.value-input{\n  width:300px;\n  text-decoration: none;\n  border: none;\n  height: 25px;\n  /* margin-top: -30px; */\n}\n\n.hospital-toggle-label {\n  font-weight: bold;\n  font-size: 18px; /* Increase label font size */\n  margin-top: 10px; /* Add some spacing between the sections */\n  border-radius: 4px;\n  /* background-color: #f8f9fc; Rounded rectangular bar background color */\n  padding: 6px 10px;\n  \n  font-size: 14px;\n  color: #02098d;\n  box-shadow: 0px 0px 2px grey;\n  width: calc(100% - 10%);\n  /* border: 1px solid #bcbcbc; */\n}\n\n\n\n/* Add styles for the billing type bar */\n.billing-type-bar {\n  font-size: 18px; /* Increase font size for the billing type bar */\n  background-color: #e2e5f9; /* Rounded rectangular bar background color */\n  padding: 5px 10px; /* Padding for the rounded rectangular bar */\n  border-radius: 10px; /* Adjust the border radius for the rounded effect */\n  display: inline-block; /* Ensure the bar wraps around the content */\n  font-size: 16px;\n}\n\n\n/* HospitalDetails.css */\n\n/* Common heading style for SLABS and Agreed Price sections */\n.section-heading {\n  font-size: 20px !important;\n  font-weight: bold !important;\n  margin-bottom: 10px;\n  text-align: center; /* Center align the heading */\n  position: sticky;\n  color: #007bff;\n  letter-spacing: 1px !important;\n}\n\n/* SLABS Section */\n.slab-section {\n  padding: 10px;\n  margin: 10px;\n  background-color: #fdfdfd; /* Set SLABS section background */\n /* border: 1px solid #e0e0e0;  Add border to SLABS section */\n border:none;\n  border-radius: 10px;\n  padding: 20px;\n  flex-grow: 1; /* Allow SLABS section to grow and take available vertical space */\n  overflow-y: auto; \n  height: calc(100vh - 260px);\n  position: sticky;\n  background-color: white;\n  box-shadow: 0px 0px 5px grey ;\n  font-family:Roboto, Helvetica, sans-serif;\n  font-size: 13px;\n}\n\n.modality-heading {\n  font-size: 18px !important;\n  font-weight: 500 !important;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  padding: 10px;\n  background-color: #e0f2f7;\n  margin-top: 10px !important;\n}\n\n.slab-data {\n  display: flex;\n  align-items: center;\n  /* margin-bottom: 10px; */\n  background-color: #f4f7f8; /* Set SLAB row background */\n  padding: 10px;\n  border-radius: 2px;\n  box-shadow: 0 1px 3px rgba(235, 133, 133, 0.1);\n}\n\n/* to target the head of the each slab */\n.slab-data-head{\n    font-weight: 700 !important;\n}\n\n.slab-data > div {\n  flex: 1;\n  padding:5px 10px;\n  text-align: center;\n}\n\n.slab-data-header {\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n  background-color: #c6bff0; /* Set SLAB column header background */\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n}\n\n.add-slabs-button {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  margin-left: 80% !important;\n  font-size: 11px !important;\n}\n\n.update-icons {\n  display: flex;\n}\n\n.update-icons > button {\n  margin-left: 5px;\n}\n\n/* Agreed Price Section */\n.agreed-price-section {\n  margin: 10px;\n  padding: 10px;\n  background-color:#FFFFFF; /* Set Agreed Price section background */\n   /* Add border to Agreed Price section */\n  border-radius: 10px;\n  box-shadow: 0 1px 5px grey;\n  flex-grow: 1; /* Allow Agreed Price section to grow and take available vertical space */\n  /* overflow-y: auto;  */\n  height: calc(100vh - 240px);\n}\n.css-rqglhn-MuiTable-root{\n overflow-y: auto;\n height: 300p;\n}\n\n.agreed-heading {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.slab-agreed-container {\n  display: flex;\n}\n\n/* HospitalDetails.css */\n\n/* ... (existing CSS code) */\n\n.buttons-container {\ndisplay: flex;\njustify-content: flex-end;\nmargin-bottom: 10px;\n}\n\n/* ... (existing CSS code) */\n.agreed-heading.section-heading {\nfont-size: 20px;\nfont-weight: bold;\nmargin-bottom: 10px;\ntext-align: center; /* Center align the heading */\ncolor: #007bff; /* Change the font color to blue (you can use any color you prefer) */\n}\n\n.css-8je8zh-MuiTouchRipple-root {\n\ncolor: white;\n}\n\n\n.details-li{\ndisplay: flex;\nbox-shadow: 0px 0px 2px grey;\ntext-decoration: none;\nmargin-bottom: 10px;\nborder-radius: 4px;\njustify-content: space-between;\n}\n\n.details-li:hover{\nbackground-color: #c6bff0;\nborder-radius: 5px;\n}\n\n.hospital-toggle-label:hover{\nbackground-color: #c6bff0;\n}\n\n.pop-edit{\ndisplay: block;\n}\n\n.pop-btn{\nbackground-color: #0056b3;\nborder: none;\npadding: 5px 10px;\nmargin-top: 10px;\nmargin-right: 20px;\nborder-radius: 50px;\nwidth: 70px;\n}\n\n.css-i4bv87-MuiSvgIcon-root{\ncursor: pointer;\n}\n\n.css-1u3bzj6-MuiFormControl-root-MuiTextField-root{\nwidth: 300px;\n\n}\n\n/* target the button in price tab */\n.price-btn{\n  margin-right: 5px !important;\n  font-size: 11px !important;\n}\n\n.edit-label>label{\n  margin-top: 0px;\n  font-size: 16px !important;\n}\n\n.edit-value{\n  overflow-x: scroll;\n  margin-right: 15px ;\n}\n\n.edit-value::-webkit-scrollbar {\n  display: none;\n}\n\n.edit-value {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n\n.price-table td,th{\n  padding: 16px;\n}\n\n/* button{\n  margin: 20px 0px 20px 0px;\n  text-align: center;\n} */\n.custom-btn {\n \n  width: 130px;\n  height: 40px;\n  color: #fff;\n  border-radius: 5px;\n  padding: 10px 25px;\n  font-family: 'Lato', sans-serif;\n  font-weight: 500;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  display: inline-block;\n   box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),\n   7px 7px 20px 0px rgba(0,0,0,.1),\n   4px 4px 5px 0px rgba(0,0,0,.1);\n  outline: none;\n}\n\n.btn-3 {\n  background: rgb(0,172,238);\nbackground: linear-gradient(0deg, rgba(0,172,238,1) 0%, rgba(2,126,251,1) 100%);\n  width: 130px;\n  height: 40px;\n  line-height: 42px;\n  padding: 0;\n  border: none;\n  \n}\n.btn-3 span {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.btn-3:before,\n.btn-3:after {\n  position: absolute;\n  content: \"\";\n  right: 0;\n  top: 0;\n   background: rgba(2,126,251,1);\n  transition: all 0.3s ease;\n}\n.btn-3:before {\n  height: 0%;\n  width: 2px;\n}\n.btn-3:after {\n  width: 0%;\n  height: 2px;\n}\n.btn-3:hover{\n   background: transparent;\n  box-shadow: none;\n}\n.btn-3:hover:before {\n  height: 100%;\n}\n.btn-3:hover:after {\n  width: 100%;\n}\n.btn-3 span:hover{\n   color: rgba(2,126,251,1);\n}\n.btn-3 span:before,\n.btn-3 span:after {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  bottom: 0;\n   background: rgba(2,126,251,1);\n  transition: all 0.3s ease;\n}\n.btn-3 span:before {\n  width: 2px;\n  height: 0%;\n}\n.btn-3 span:after {\n  width: 0%;\n  height: 2px;\n}\n.btn-3 span:hover:before {\n  height: 100%;\n}\n.btn-3 span:hover:after {\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
